import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"


import { ref, onMounted, computed } from 'vue'
import { FollowAlarmParams } from '@/typings/api/analysis'
import { followAlarmGet } from '@/api/gucangSales/analysis'
import EditorTableText from '@/components/Editor/src/tableText.vue'
import { listByParamCodes } from '@/api/common'
import { alarmTypeEnum, alarmLevelEnum, alarmProcessStatusEnum } from '@/views/gucangSales/commonEnum/dataConfig'
const __default__ = { name: 'DcCosFbuFollowChangeFeedback' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  cosId: {
    type: String,
    require: true
  }
},
  setup(__props) {

const paramCodeData = ref<any>({
  fbu_change_description: [] // 异动说明
})
const props = __props
const columns = computed(() => [
  {
    title: '异动触发时间',
    dataIndex: 'alarmDate'
  },
  {
    title: '子客户代码',
    dataIndex: 'arkCode'
  },
  {
    title: '异动类型',
    dataIndex: 'alarmType',
    dicData: alarmTypeEnum
  },
  {
    title: '异动级别',
    dataIndex: 'alarmLevel',
    dicData: alarmLevelEnum
  },
  {
    title: '异动原因',
    dataIndex: 'alarmInfo'
  },
  {
    title: '异动说明',
    dataIndex: 'alarmDesc',
    dicData: paramCodeData.value.fbu_change_description
  },
  {
    title: '具体详情',
    dataIndex: 'process'
  },
  {
    title: '反馈时间',
    dataIndex: 'processTime'
  },
  {
    title: '反馈情况',
    dataIndex: 'processStatus',
    dicData: alarmProcessStatusEnum
  }
])
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: ['fbu_change_description']
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.value = res.data
    }
  })
}
const fetch = (params: FollowAlarmParams, callBack: (res: any) => void) => {
  if (!props.cosId) {
    callBack({
      items: [],
      pageNumber: 1,
      pageSize: 10,
      totalCount: 0,
      totalPage: 0
    })
    return
  }
  followAlarmGet({
    ...params,
    cosId: props.cosId
  }).then((res) => {
    callBack(res)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_cos_table = _resolveComponent("cos-table")!

  return (_openBlock(), _createBlock(_component_cos_table, {
    columns: columns.value,
    onFetch: fetch,
    tableId: "fbuClientsFollowChangeFeedback"
  }, {
    bodyCell: _withCtx(({ column, text }) => [
      (column.dataIndex === 'process')
        ? (_openBlock(), _createBlock(EditorTableText, {
            key: 0,
            value: text
          }, null, 8, ["value"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["columns"]))
}
}

})